var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copied from https://github.com/MSalmanTariq/react-google-one-tap-login
import { memo } from 'react';
import { useGoogleOTIntegration } from './useGoogleOTIntegration';
function GoogleOTIntegrationInternal(_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, props = __rest(_a, ["children"]);
    useGoogleOTIntegration(props);
    return children;
}
export var GoogleOTIntegration = memo(GoogleOTIntegrationInternal);
//# sourceMappingURL=index.js.map